import { useDispatch, useSelector } from "react-redux"

import { useEffect } from "react"
import BankSelection from "../../pages/BankSelection"
import SuccessLinking from "../../pages/SuccessLinking"
import { setBank } from "../../store/slices/linkingSlice"
import { IBankMeta } from "../../api/interface"
import { usePaymentLink } from "../../api/hooks/usePaymentLink"
import { RootState } from "../../store/store"
import {
  accountLinkingSteps,
  STEPS_NAME,
} from "../../store/slices/routingSlice/flowsSteps"
import {
  setCurrentFlow,
  setCurrentStep,
  setNextStep,
} from "../../store/slices/routingSlice/routingSlice"

const LinkingFlow = () => {
  const dispatch = useDispatch()

  const linkingSteps = useSelector(
    (state: RootState) => state.routing.routes.accountLinking.currentStep,
  )

  const { mutateAsync, isPending, data } = usePaymentLink()

  const requestId = data?.linkingRequestId
  const bankSelectDescription = "Выбери банк, в котором открыт твой счет"

  const handleBankClick = async (bank: IBankMeta) => {
    try {
      dispatch(setBank(bank))
      await mutateAsync(bank.bankId)
      if (!isPending) {
        dispatch(setNextStep())
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error linking bank:", error)
    }
  }

  useEffect(() => {
    dispatch(setCurrentFlow("accountLinking"))
    dispatch(setCurrentStep(STEPS_NAME.linking.linkingBankSelection))
  }, [])

  switch (linkingSteps) {
    case accountLinkingSteps.linkingBankSelection.name: {
      return (
        <BankSelection
          handleBankClick={handleBankClick}
          bankSelectDescription={bankSelectDescription}
          isLoading={isPending}
        />
      )
    }
    case accountLinkingSteps.successLinking.name: {
      return <SuccessLinking requestId={requestId} />
    }
    default: {
      return (
        <BankSelection
          handleBankClick={handleBankClick}
          bankSelectDescription={bankSelectDescription}
          isLoading={isPending}
        />
      )
    }
  }
}

export default LinkingFlow
